import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';
import { keyBy, keyByProperty } from '../../../../helpers/core';
import { t } from '../../../../i18n';

const initState = {
  attire: null,
  editAttireForm: null,
  loading: false,
};

function validate(attr, value) {
  let error = '';

  if (attr === 'group_id') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.admin.attires.columns.id_title') });
    }
  }

  return error;
}

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const attire = data;
  const propsArray = Object.keys(attire);

  const editAttireForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: attire[prop],
      error: validate(prop, attire[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    attire,
    loading: false,
    editAttireForm,
  };
}

function onClearStore() {
  return { ...initState };
}

function onSave(state, { payload }) {
  const propsArray = Object.values(payload.editAttireForm);
  const attire = keyByProperty(propsArray, 'name', prop => prop.value);

  return {
    ...state,
    editAttireForm: null,
    attire,
  };
}

function onSaveSuccess(state, { payload }) {
  const { id } = payload;

  return {
    ...state,
    editAttireForm: null,
    attire: { ...state.attire, id },
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editAttireForm } = state;

  editAttireForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editAttireForm: {
      ...editAttireForm,
    },
  };
}

function onChangeProperties(state, { payload }) {
  const { attributes } = payload;
  const propsArray = Object.keys(attributes);

  const editAttireFormProps = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: attributes[prop],
      error: validate(prop, attributes[prop]),
      touched: true,
    }),
  );

  const editAttireForm = {
    ...state.editAttireForm,
    ...editAttireFormProps,
  };

  return {
    ...state,
    editAttireForm,
  };
}

function onCancel(state) {
  return {
    ...state,
    editAttireForm: null,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editAttireForm);
  const editAttireForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editAttireForm,
  };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CHANGE_PROPERTIES]: onChangeProperties,
  [actions.CANCEL]: onCancel,
  [actions.SAVE]: onSave,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.TOUCH]: onTouch,
});
